// imports
import DrupalView from 'minsky-kit/js/components/DrupalView';
import AnalystMap from './AnalystMap';
import DropdownDrupalFilter from './DropdownDrupalFilter';
import Tabs from './Tabs';
import tippy from 'tippy.js';
import 'tippy.js/animations/shift-away.css';

// private statics

// class definition
export default class AnalystView extends DrupalView {
    // constructor
    constructor (args = {}, objectName = 'AnalystView') {
        args.debug = args.debug || true;

        // super
        super(args, objectName);

        // add listeners
        this.on('view_refresh', onViewRefresh);

        this.isArchive = args.isArchive || false;
        this.analystStorage = args.analystStorage;

        this.typeFilterChanged = false;
        this.genreFilterChanged = false;
        this.$favoritesFilter = false;

        this.urlParams = new URLSearchParams(window.location.search);

        initView.call(this);
    }

    applyFavoritesFilter() {
        if(this.$serviceFilter) {
            this.$serviceFilter.crMultiSelect.$select.value = null;
        }

        if(this.$languageFilter) {
            this.$languageFilter.crMultiSelect.$select.value = null;
        }

        if(this.$backgroundFilter) {
            this.$backgroundFilter.crMultiSelect.$select.value = null;
        }

        this.$favoritesFilter.value = window.localStorage.getItem('favorites') ? window.localStorage.getItem('favorites').split(',').join('+') : 'none';

        console.log(this.$favoritesFilter.value);

        this._$submit.click();
    }

    resetFavoritesFilter() {
        this.$favoritesFilter.value = '';
        this._$submit.click();
    }

    // methods
    refresh (...args) {
        super.refresh(...args);
    }

    show (...args) {
        super.show(...args);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils
function initView () {
    this._$submit = this.$el.querySelector('.form-submit');
    if (this._$submit) {
        this._$submit.value = Drupal.t('minskyString.analysts.filter');
    }
    // this._$submit.classList.add('noRender');

    this.$serviceFilter = this.$el.querySelector('.views-exposed-form .form-item-field-services');
    this.$languageFilter = this.$el.querySelector('.views-exposed-form .form-item-field-language');
    this.$backgroundFilter = this.$el.querySelector('.views-exposed-form .form-item-field-background');
    this.$favoritesFilter = this.$el.querySelector('.views-exposed-form .form-item-analyst-uuid textarea');

    if (this.$serviceFilter) {
        this.$serviceFilter = new DropdownDrupalFilter({
            $el: this.$serviceFilter,
        });

        this.serviceFilterChanged = false;

        this.$serviceFilter.on('change', this.blm.addOnce('onServiceFilterChange', onServiceFilterChange));
    }

    if (this.$languageFilter) {
        this.$languageFilter = new DropdownDrupalFilter({
            $el: this.$languageFilter,
        });

        this.languageeFilterChanged = false;

        this.$languageFilter.on('change', this.blm.addOnce('onLanguageFilterChange', onLanguageFilterChange));
    }

    if (this.$backgroundFilter) {
        this.$backgroundFilter = new DropdownDrupalFilter({
            $el: this.$backgroundFilter,
        });

        this.backgroundeFilterChanged = false;

        this.$backgroundFilter.on('change', this.blm.addOnce('onBackgroundFilterChange', onBackgroundFilterChange));
    }

    //tabs
    const $viewFilterTabs = this.$el.querySelector('.view-filter__tabs');
    if ($viewFilterTabs) {
        const tabs = [];
        const $items = $viewFilterTabs.querySelectorAll('.tab');

        $items.forEach(($i) => {
            let disabled = false;
            const isFavorites = $i.querySelector('.favorites-view');
            if(isFavorites) {
                if(!this.analystStorage.getAnalysts().length) {
                    disabled = true;
                };
            }

            const tab = {
                trigger: $i.querySelector('.tab__title'),
                content: $i,
                disabled
            };
            tabs.push(tab);
        });

        if (window.location.href.includes('tab=favorites')) {
            if(this.analystStorage.getAnalysts().length) {
                if(!this.$favoritesFilter.value.length) {
                    this.applyFavoritesFilter();
                }
            }
        }
    

        const viewFilterTabs = new Tabs({
            $el:   $viewFilterTabs,
            tabs,
            activeIndex: this.$favoritesFilter.value.length > 1 ? this.$favoritesFilter.value === 'none' ? 1 : 2 : 1
        });

        viewFilterTabs.on('tabChanged', this.blm.addOnce('onTabChange', onTabChange))
    }



    // this._$submit.classList.add('noRender');
    const $map = this.$el.querySelector('.view__map');
    const analysts = this.$el.querySelectorAll('.analyst-teaser');
    if($map) {
        new AnalystMap({
            $el: $map,
            analysts: analysts
        });
    }

    const $analystRemoves = document.querySelectorAll('.js-analyst-remove');
    if($analystRemoves.length) {
        $analystRemoves.forEach($ar => {
            tippy($ar, {
                content: $ar.dataset.title,
                theme: 'masterclass',
                placement: 'top',
                animation: 'shift-away'
            })

            $ar.addEventListener('click', e => {
                e.preventDefault();
                this.analystStorage.remove($ar.dataset.id);
                this.applyFavoritesFilter();
            });
        });
    }
}

// Event handlers
function onViewRefresh () {
    initView.call(this);
}

function onTabChange(e) {
    if(e.data.tabId == 2 && this.$favoritesFilter.value.length < 1) {
        //do the filter stuff
        console.log('APPLY')
        this.applyFavoritesFilter();

    } else if(e.data.tabId == 1 && this.$favoritesFilter.value.length > 1) {
        console.log('RESET')
        this.resetFavoritesFilter();

        // remove tab param
        const url = new URL(location);
        url.searchParams.delete('tab');
        history.pushState(null, document.title, url);
    }
}

function onLanguageFilterChange () {
    this._$submit.click();
}

function onServiceFilterChange () {
    this._$submit.click();
}

function onBackgroundFilterChange () {
    this._$submit.click();
}

function onFilterChange () {
    this._$submit.click();
}

function gup (name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    const regexS = `[\\?&]${name}=([^&#]*)`;
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    return results == null ? null : results[1];
}
